import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Yaohao = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 20 20"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="c73ce__a">
              <rect
                rx="0"
                height="20"
                width="20"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#c73ce__a)"
            fill="#1FB4FF"
          >
            <path
              d="M18.333 13.75H1.667v4.167h16.666V13.75Z"
              data-follow-fill="#1FB4FF"
              fill={_fill}
            />
            <path
              fillRule="evenodd"
              d="M1.042 17.917V13.75c0-.345.28-.625.625-.625h16.666c.345 0 .625.28.625.625v4.167c0 .345-.28.625-.625.625H1.667a.625.625 0 0 1-.625-.625Zm16.666-3.542H2.292v2.917h15.416v-2.917Z"
              data-follow-fill="#1FB4FF"
              fill={_fill}
            />
            <path
              fillRule="evenodd"
              d="M10.208 13.75v-2.917c0-.345.28-.625.625-.625h5c.346 0 .625.28.625.625v2.917c0 .345-.28.625-.625.625h-5a.625.625 0 0 1-.625-.625Zm5-2.292h-3.75v1.667h3.75v-1.667Z"
              data-follow-fill="#1FB4FF"
              fill={_fill}
            />
            <path
              d="M9.583 3.75q0 .102-.01.204t-.03.202q-.02.1-.05.199-.03.098-.068.192-.04.095-.088.185-.048.09-.105.175-.057.086-.122.165-.065.079-.137.151-.072.073-.151.137-.08.065-.165.122-.085.057-.175.105-.09.049-.185.088-.094.039-.192.069-.098.03-.199.05-.1.02-.202.03-.102.01-.204.01t-.204-.01q-.102-.01-.202-.03-.1-.02-.199-.05-.098-.03-.192-.07-.095-.038-.185-.087-.09-.048-.175-.105-.086-.057-.165-.122-.079-.064-.151-.137-.073-.072-.137-.151-.065-.08-.122-.165-.057-.085-.105-.175-.049-.09-.088-.185-.039-.094-.069-.192-.03-.098-.05-.199-.02-.1-.03-.202-.01-.102-.01-.204t.01-.204q.01-.102.03-.202.02-.1.05-.199.03-.098.07-.192.038-.095.087-.185.048-.09.105-.175.057-.086.122-.165.064-.079.137-.151.072-.072.151-.137.08-.065.165-.122.085-.057.175-.105.09-.049.185-.088.094-.039.192-.069.098-.03.199-.05.1-.02.202-.03.102-.01.204-.01t.204.01q.102.01.202.03.1.02.199.05.098.03.192.07.095.038.185.087.09.048.175.105.085.057.165.122.079.065.151.137.072.072.137.151.065.08.122.165.057.085.105.175.049.09.088.185.039.094.069.192.03.098.05.199.02.1.03.202.01.102.01.204Z"
              data-follow-fill="#1FB4FF"
              fill={_fill}
            />
            <path
              fillRule="evenodd"
              d="M5.585 1.835q-.793.793-.793 1.915 0 1.122.793 1.915.793.793 1.915.793 1.122 0 1.915-.793.793-.793.793-1.915 0-1.122-.793-1.915-.793-.793-1.915-.793-1.122 0-1.915.793Zm.884 2.946q-.427-.427-.427-1.031 0-.604.427-1.031.427-.427 1.031-.427.604 0 1.031.427.427.427.427 1.031 0 .604-.427 1.031-.427.427-1.031.427-.604 0-1.031-.427Z"
              data-follow-fill="#1FB4FF"
              fill={_fill}
            />
            <path
              fillRule="evenodd"
              d="M3.164 13.534a.625.625 0 0 0-.039.216v.025a.625.625 0 0 0 .625.6h.015a.625.625 0 0 0 .571-.409L7.253 6.05a.625.625 0 0 0 .039-.217V5.81a.625.625 0 0 0-.625-.6h-.015a.625.625 0 0 0-.572.408l-2.916 7.917Z"
              data-follow-fill="#1FB4FF"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
